export default __webpack_public_path__ + "static/media/textures.df89c72b.png";